import apiClient from '../../../common/services/apiClient';

export const apiCallIds = {
  FETCH_DASHBOARD_DATA: 'FETCH_DASHBOARD_DATA',
};

export default {
  fetchReportData: () => {
    return apiClient.get(`/adminDashboard`);
  }
};



// WEBPACK FOOTER //
// ./src/features/admin-dashboard/api/index.js